import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-262921a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "niceUl" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "名前", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "住所", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "電話番号", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "担当者", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "種別", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, [
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_ctx.data.name) + "(" + _toDisplayString(_ctx.data.furigana) + ")", 1)
    ]),
    _createElementVNode("li", null, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.data.addressDetails), 1)
    ]),
    _createElementVNode("li", null, [
      _hoisted_4,
      _createTextVNode(" " + _toDisplayString(_ctx.data.tel), 1)
    ]),
    (_ctx.data.personName)
      ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.data.personName) + "(" + _toDisplayString(_ctx.data.personNameFurigana) + ")", 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("li", null, [
      _hoisted_7,
      _createTextVNode(_toDisplayString(_ctx.getTypeJa(_ctx.data.type)), 1)
    ])
  ]))
}